import React, { useEffect, useState } from "react";
import { useEventos } from "../../context/EventosContext";

const CalendarDay = ({
  day,
  month,
  year,
  eventosDelDia = [],
  selectedDate,
  onDateClick,
}) => {
  const [maxEventosVisibles, setMaxEventosVisibles] = useState(3); // Valor predeterminado

  // Detectar cambios en el tamaño de la pantalla
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 720) {
        setMaxEventosVisibles(1); // Modo móvil
      } else {
        setMaxEventosVisibles(3); // Modo escritorio
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Llamar al cargar

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const eventosVisibles = eventosDelDia.slice(0, maxEventosVisibles);
  const eventosRestantes = eventosDelDia.length - maxEventosVisibles;
  // const { fetchEventosPorFecha } = useEventos();

  const isSelected =
    new Date(year, month, day).toISOString().split("T")[0] === selectedDate;

  const handleDayClick = () => {
    const selectedDate = new Date(year, month, day).toISOString().split("T")[0]; 
    // fetchEventosPorFecha(selectedDate);
    onDateClick(selectedDate);
  };

  return (
    <div
      className={`flex flex-col justify-between border rounded-xl p-2 sm:p-3 h-full sm:h-28 sm:w-24 text-center relative cursor-pointer hover:shadow-md 
        ${isSelected ? "bg-blue-100 border-blue-500" : "border-gray-300"}`}
      onClick={handleDayClick}
    >
      <div className="text-left w-full">
        <span className="text-main-bg-sidebar font-bold text-base sm:text-lg">{day}</span>
      </div>

      {/* Contenedor de círculos usando grid */}
      <div className="grid grid-cols-3 gap-1 mt-1 sm:mt-2">
        {eventosVisibles.map((evento, index) => (
          <span
            key={index}
            className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full"
            style={{ backgroundColor: evento.color }}
          ></span>
        ))}
        {eventosRestantes > 0 && (
          <span className="text-xs sm:text-sm font-bold text-blue-900 col-span-3">
            +{eventosRestantes}
          </span>
        )}
      </div>
    </div>
  );
};

export default CalendarDay;
